module.exports = __webpack_public_path__ + "img/footprint.a47c6de8.svg";